import CreateAgencyPromotion from './CreateAgencyPromotion.container';

export default CreateAgencyPromotion;
